
import Vue from 'vue';
import { Getter, Action } from 'vuex-class';
import { Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import * as util from '../conf';
import { Message,MessageBox } from 'element-ui';

@Component
export default class FeedbackEntranceComponent extends Vue {
  @Action('getIsProductUser') getIsProductUser: Function;
  @Action('getIsSubmitBugByUser') getIsSubmitBugByUser: Function;
  @Getter isProductUser: any;
  @Getter isSubmitBugByUser: any;
  entranceData: Array<{ [key: string]: any }> = [
    {
      icon: 'iconchanpinbug',
      name: '产品BUG',
      text:
        '如遇到如系统故障、系统报错、数据/功能/界面错误等问题（不仅限系统BUG），请选择产品BUG~',
      to: '/feedback/entrance/defect',
      disabled: false
    },
    {
      icon: 'iconchanpinjianyi',
      name: '产品建议',
      text:
        '如对产品设计/功能/业务逻辑等层面的优化改进建议或对产品场景的补充，请选择产品建议~',
      to: '/feedback/entrance/proposal'
    },
    {
      icon: 'iconchanpinzixun',
      name: '产品咨询',
      text:
        '如对产品有任何疑问（如产品业务咨询、产品功能操作、产品技术实现等），请选择产品咨询~',
      to: '/feedback/entrance/consultation'
    }
  ];
  userType: string = 'other';
  isSubmitBug:boolean = true;
  created() {
    this.getUserAreaType();    
  }
  getUserAreaType(){
    const user = JSON.parse(localStorage.logonUser);
    this.getIsProductUser({userCode:user.UserCode});
    this.getIsSubmitBugByUser({userCode:user.UserCode});
  }
  @Watch('isProductUser.loading')
  watchIsProductUserLoading(newVal: boolean, oldVal: boolean) {    
    if (oldVal === true && newVal === false) {      
      this.userType=this.isProductUser.data?'other':'qygs';
      localStorage.setItem('userType',this.userType);
    }
  }
  @Watch('isSubmitBugByUser.loading')
  watchIsSubmitBugByUserLoading(newVal: boolean, oldVal: boolean) {    
    if (oldVal === true && newVal === false) {      
      this.isSubmitBug = this.isSubmitBugByUser.data;      
    }
  }

  handlerClick(item: any) {    
    // if(item.name=="产品BUG"&&this.isSubmitBug==false){
    //   this.$alert("项目体系（含ODC）、运维体系，请通过升级通道提交产品BUG。",{center: true});
    //   return ;
    // }
    if (!item.disabled) {
      this.$router.push({ path: item.to});
    }
  }
}
